export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            关于白云视频
          </h2>
        </div>
        <div className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-10">
          <div className="max-w-3xl">
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
              白云视频是一个专注于<strong>高清影视资源聚合</strong>的在线观影平台，致力于为广大影迷提供丰富、便捷、流畅的观影体验。
              平台汇聚了<strong>最新电影、热播电视剧、综艺节目、动漫番剧</strong>以及各类独家剧集，覆盖动作、喜剧、悬疑、科幻、爱情、古装等全品类内容。
            </p>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mt-4">
              我们与<strong>97视频、丝瓜视频、蓝莓视频、91在线视频</strong>等主流平台保持同步更新，确保片源丰富、画质高清。
              全站采用智能分发技术，支持多线路自动切换，保障播放流畅不缓冲。无论是院线新片还是经典老片，白云视频都力求为你呈现最佳的在线观影选择。
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8">
              {[
                { value: '20,000+', label: '影视资源' },
                { value: '15+', label: '内容分类' },
                { value: '128部/日', label: '更新速度' },
                { value: '99.9%', label: '播放成功率' },
              ].map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="font-heading text-2xl md:text-3xl font-extrabold text-primary-500">{stat.value}</div>
                  <div className="text-foreground-400 text-xs md:text-sm mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}